import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-formulario-alcance',
  templateUrl: './formulario-alcance.component.html',
  styleUrls: ['./formulario-alcance.component.scss']
})
export class FormularioAlcanceComponent {
  form: FormGroup;
  title = "Alcance";

  constructor(
    private fb: FormBuilder,
    private util: Util,
    private dialogRef: MatDialogRef<FormularioAlcanceComponent>
  ) {
    this.form = this.fb.group({
      isNominal: [null], 
      numero: [''], 
      vInicial: [''], 
      vFinal: ['']
    }, { validators: this.validarValores });

    this.form.get('isNominal')?.valueChanges.subscribe(value => {
      this.limpiarCampos();
    });
  }


  validarValores(form: AbstractControl): ValidationErrors | null {
    const isNominal = form.get('isNominal')?.value;
    const vInicial = form.get('vInicial')?.value;
    const vFinal = form.get('vFinal')?.value;

    if (isNominal === false) { 
      if (vInicial === null || vFinal === null) {
        return { valoresRequeridos: true }; 
      }
      if (vInicial > vFinal) {
        return { valoresInvalidos: true }; 
      }
    }
    return null; 
  }

  limpiarCampos() {
    this.form.patchValue({
      vInicial: '',
      vFinal: '',
      numero: ''
    });
    this.form.updateValueAndValidity(); 
  }


  enviar() {
    if (this.form.valid) {
      this.dialogRef.close({ success: true, data: this.form.value }); 
    } else {
      if (this.form.hasError('valoresInvalidos')) {
        this.util.errorMessage("'Valor Inicial' debe ser MAYOR o IGUAL que 'Valor Final'");
      }
      if (this.form.hasError('valoresRequeridos')) {
        this.util.errorMessage("Debes ingresar 'Valor Inicial' y 'Valor Final'");
      }
    }
  }
}
